import { ForgotPassword } from './ForgotPassword'

export const ForgotPage = () => {
  return <ForgotPassword />
}

export default ForgotPage
